module.exports = __webpack_public_path__ + "img/vespa_315.6499b343.png";